import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import styles from './SectionServices.module.scss';
import { services } from '@/data/services';

const SectionServices: React.FC = () => {
  return (
    <section className={`${styles.servicesSection} dark-section`} id="home-services">
      <div className="torn-edge-top" />
      <div className="container">
        <motion.div
          className={styles.headingWrapper}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className={styles.heading}>WHAT WE BUILD.</h2>
          <div className="gradient-line"></div>
        </motion.div>

        <div className={styles.servicesList}>
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              className={styles.serviceRow}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Link to={`/services`} className={styles.serviceLink}>
                <div className={styles.rowContent}>
                  <span className={styles.number}>{String(index + 1).padStart(2, '0')}</span>
                  <h3 className={styles.title}>{service.title}</h3>
                  <p className={styles.description}>{service.description.split('.')[0]}.</p>
                </div>
                <div className={styles.arrowIcon}>
                  <ArrowRight size={24} />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectionServices;
